import { HEADERCONTEXT_DATA } from "../actionConstants";

const initialState = {};

export default function (state = initialState, action) {
    switch (action.type) {
        case HEADERCONTEXT_DATA: {
            return Object.assign({}, state, action.payload);
        }
        default:
            return state;
    }
}
